module.exports = __webpack_public_path__ + "img/14.b7c3b617.jpg";